import { useCallback, useMemo, useRef, useState } from "react";

export default function usePendingFileUploads() {
  const pendingUploadsRef = useRef(new Map());
  const [pendingUploads, setPendingUploads] = useState([]);

  const sync = useCallback(() => {
    setPendingUploads(Array.from(pendingUploadsRef.current.values()));
  }, []);

  const startUpload = useCallback((key, fileName) => {
    pendingUploadsRef.current.set(key, {
      key,
      fileName: fileName || "Arquivo",
      percent: 0,
      status: "uploading",
    });
    sync();
  }, [sync]);

  const updateUpload = useCallback((key, changes = {}) => {
    const current = pendingUploadsRef.current.get(key);
    if (!current) return;
    pendingUploadsRef.current.set(key, { ...current, ...changes });
    sync();
  }, [sync]);

  const finishUpload = useCallback((key) => {
    pendingUploadsRef.current.delete(key);
    sync();
  }, [sync]);

  const getUpload = useCallback((key) => pendingUploadsRef.current.get(key) || null, []);

  const getTableUploadCount = useCallback((fieldId) => {
    const prefix = `table:${fieldId}:`;
    let count = 0;
    pendingUploadsRef.current.forEach((_, key) => {
      if (String(key).startsWith(prefix)) count += 1;
    });
    return count;
  }, []);

  const getTableRowUploadCount = useCallback((fieldId, rowIndex) => {
    const prefix = `table:${fieldId}:${rowIndex}:`;
    let count = 0;
    pendingUploadsRef.current.forEach((_, key) => {
      if (String(key).startsWith(prefix)) count += 1;
    });
    return count;
  }, []);

  const count = pendingUploads.length;

  return useMemo(() => ({
    pendingUploadsRef,
    pendingUploads,
    pendingUploadsCount: count,
    hasPendingUploads: count > 0,
    startUpload,
    updateUpload,
    finishUpload,
    getUpload,
    getTableUploadCount,
    getTableRowUploadCount,
  }), [pendingUploads, count, startUpload, updateUpload, finishUpload, getUpload, getTableUploadCount, getTableRowUploadCount]);
}
